"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[729],{

/***/ 30729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_elastic_carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27082);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_3__);




var HomeConferences = function(param) {
    var data = param.data;
    var catouselRefSM = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var catouselRefMD = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var catouselRefLG = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), resetTimeout = ref[0], setResetTimeout = ref[1];
    var onNextStart = function(currentItem, nextItem, element) {
        if (currentItem.index === nextItem.index) {
            element.current.goTo(0);
        }
    };
    var onPrevStart = function(currentItem, nextItem, element) {
        if (currentItem.index === nextItem.index) {
            element.current.goTo(data.length);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // Clear the timeout when the component unmounts
        return function() {
            return clearTimeout(resetTimeout);
        };
    }, [
        resetTimeout
    ]);
    var awardCard = function(data, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: data.event_url,
            className: "conference-card my-4 d-flex justify-content-center flex-column position-relative",
            target: "_blank",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: data.event_logo,
                alt: "".concat(data.event_name, " Event Hosted by KonfHub"),
                fill: true
            })
        }, index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "conference-container py-md-3 px-md-4 py-5 px-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row g-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col py-md-5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "conference-title text-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "theme-text",
                                            children: "Conferences"
                                        }),
                                        " Hosted on Us"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "conference-sub-title text-center",
                                    children: "Used by large conferences, active meetups and buzzing communities"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row g-0 py-3 mt-3 px-md-5 py-md-0 pb-md-5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col d-none d-md-none d-lg-block",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_elastic_carousel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ref: catouselRefLG,
                                    itemsToShow: 5,
                                    isLTR: true,
                                    enableAutoPlay: true,
                                    autoPlaySpeed: 3000,
                                    onNextEnd: function(param) {
                                        var index = param.index;
                                        clearTimeout(resetTimeout);
                                        setResetTimeout(setTimeout(function() {
                                            catouselRefLG.current.goTo(0);
                                        }, 4000));
                                    },
                                    onNextStart: function(currentItem, nextItem) {
                                        return onNextStart(currentItem, nextItem, catouselRefLG);
                                    },
                                    onPrevStart: function(currentItem, nextItem) {
                                        return onPrevStart(currentItem, nextItem, catouselRefLG);
                                    },
                                    disableArrowsOnEnd: false,
                                    disableArrowsOnStart: false,
                                    children: data.map(awardCard)
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col d-none d-md-block d-lg-none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_elastic_carousel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ref: catouselRefMD,
                                    itemsToShow: 3,
                                    isLTR: true,
                                    enableAutoPlay: true,
                                    autoPlaySpeed: 3000,
                                    onNextEnd: function(param) {
                                        var index = param.index;
                                        clearTimeout(resetTimeout);
                                        setResetTimeout(setTimeout(function() {
                                            catouselRefMD.current.goTo(0);
                                        }, 4000));
                                    },
                                    onNextStart: function(currentItem, nextItem) {
                                        return onNextStart(currentItem, nextItem, catouselRefMD);
                                    },
                                    onPrevStart: function(currentItem, nextItem) {
                                        return onPrevStart(currentItem, nextItem, catouselRefMD);
                                    },
                                    disableArrowsOnEnd: false,
                                    disableArrowsOnStart: false,
                                    children: data.map(awardCard)
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col d-block d-md-none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_elastic_carousel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ref: catouselRefSM,
                                    itemsToShow: 1,
                                    isLTR: true,
                                    enableAutoPlay: true,
                                    autoPlaySpeed: 3000,
                                    onNextEnd: function(param) {
                                        var index = param.index;
                                        clearTimeout(resetTimeout);
                                        setResetTimeout(setTimeout(function() {
                                            catouselRefSM.current.goTo(0);
                                        }, 4000));
                                    },
                                    onNextStart: function(currentItem, nextItem) {
                                        return onNextStart(currentItem, nextItem, catouselRefSM);
                                    },
                                    onPrevStart: function(currentItem, nextItem) {
                                        return onPrevStart(currentItem, nextItem, catouselRefSM);
                                    },
                                    disableArrowsOnEnd: false,
                                    disableArrowsOnStart: false,
                                    children: data.map(awardCard)
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: "\n      .conference-container {\n    background: #F6F9FC;\n}\n\n.conference-container .conference-title {\n    color: #572148;\n    font-weight: 700;\n    font-size: 50px;\n    font-family: \"Nunito\";\n}\n\n.conference-container .conference-title .theme-text {\n    color: #FB5850;\n}\n\n.conference-container .conference-sub-title {\n    font-family: 'Nunito';\n    font-weight: 400;\n    font-size: 22px;\n    color: #636363;\n}\n\n.conference-card{\n    background: #23313E;\n    border: 4px solid #FFFFFF;\n    box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.25);\n    border-radius: 0.5px;\n    width: 229px;\n    height: 118px;\n}\n\n.conference-card img{\n    width: 100%; /* or any custom size */\n    height: 100%;\n    object-fit: contain;\n}\n\n\n/* SM screens */\n@media only screen and (min-width: 480px) and (max-width: 768px) {\n    .conference-container .conference-title {\n        font-size: 30px;\n    }\n\n    .conference-container .conference-sub-title {\n        font-size: 16px;\n    }\n}\n\n/* XS screens */\n@media only screen and (max-width: 480px) {\n    .conference-container .conference-title {\n        font-size: 30px;\n    }\n\n    .conference-container .conference-sub-title {\n        font-size: 16px;\n    }\n}\n      "
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HomeConferences);


/***/ })

}]);